<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";
import Table from "@/components/role/users/components/UserTable"

/**
 * Form elements component
 */
export default {
  page: {
    title: "Roles de usuario",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
  },
  data() {
    return {
      title: "Roles de usuario",
      items: [
        {
          text: "",
          href: "/",
        },
        {
          text: "",
          href: "/",
        },
        {
          text: "",
          active: true,
        },
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goRegisterPage() {
      this.$router.push({
        name: "registro-rol",
        params: {
          id: this.$route.params.id,
        },
      });
    },

  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group text-right m-b-0">
              <div class="col-12 text-right m-b-0">
                <!--
                <div @click="goRegisterPage" class="btn btn-primary m-l-5 ml-1">
                  Agregar
                </div>
                -->

                <div @click="goBack" id="tooltip" class="btn btn-secondary m-l-5 ml-1">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

            <div class="col-12">
              <Table />
            </div>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>


  </Layout>
</template>
